import axios from 'axios';

import { CONFIG } from 'src/config-global';
import { apiEndpoints } from '@utils/api-endpoints';
import { signOut } from 'src/auth/context/jwt';
import { toast, unauthorizedToast } from 'src/components/snackbar';

// Create a new axios instance for Tairra API
export const tairraAxiosInstance = axios.create({ baseURL: CONFIG.tairraApiUrl });
export const PublictairraAxiosInstance = axios.create({ baseURL: CONFIG.tairraApiUrl });

tairraAxiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const errorMessage = (error.response && error.response.data) || 'Something went wrong!';

    // Handle specific status codes (e.g., 401 Unauthorized)
    if (error.response?.status === 401) {
      console.warn('Unauthorized - token might be invalid or expired.');

      // Trigger sign out if the user is unauthorized
      await signOut();

      window.location.href = '/auth/jwt/sign-in/'; // Adjust this path as needed

      // Optionally, redirect to login page if needed (if on client-side)
      // window.location.href = '/login'; // Adjust this path as needed
    }

    return Promise.reject(errorMessage);
  }
);

export default tairraAxiosInstance;

export const fetcher = async (args) => {
  try {
    const [url, config] = Array.isArray(args) ? args : [args];

    const res = await tairraAxiosInstance.get(url, { ...config });

    return res.data;
  } catch (error) {
    console.error('Failed to fetch:', error);
    throw error;
  }
};

export const publicfetcher = async (args) => {
  try {
    const [url, config] = Array.isArray(args) ? args : [args];

    const res = await PublictairraAxiosInstance.get(url, { ...config });

    return res.data;
  } catch (error) {
    console.error('Failed to fetch:', error);
    throw error;
  }
};

// POST Fetcher function
export const postFetcher = async (args) => {
  try {
    const [url, data, config] = Array.isArray(args) ? args : [args, {}, {}];

    const res = await tairraAxiosInstance.post(url, data, { ...config });

    return res.data;
  } catch (error) {
    console.error('Failed to post:', error);
    throw error;
  }
};

// GET Fetcher function
export const fetchGetRequest = async (args) => {
  try {
    const [url, data, config] = Array.isArray(args) ? args : [args, {}, {}];

    const res = await tairraAxiosInstance.get(url, data, { ...config });

    return res.data;
  } catch (error) {
    console.error('Failed to get:', error);
    throw error;
  }
};

export const handlePostRequestWithArg = async (url, data) => {
  const payload = data.arg;

  try {
    const response = await tairraAxiosInstance.post(url, payload);
    return response.data;
  } catch (error) {
    console.error('Failed to post:', error);
    throw error;
  }
};

export const handleDeleteRequestWithArg = async (url, data) => {
  const payload = data.arg;

  try {
    const response = await tairraAxiosInstance.delete(url, payload);
    return response.data;
  } catch (error) {
    console.error('Failed to delete:', error);
    throw error;
  }
};

export const handleGetRequestWithArg = async (url, data) => {
  const payload = data?.arg;

  try {
    const response = await tairraAxiosInstance.get(url, payload);
    return response.data;
  } catch (error) {
    console.error('Failed to get:', error);
    throw error;
  }
};

export const handlePutRequestWithArg = async (url, data) => {
  try {
    console.log('running after this', url, data);

    const response = await tairraAxiosInstance.put(url, data);
    return response.data;
  } catch (error) {
    console.error('Failed to update:', error);
    throw error;
  }
};
export const handlePutRequestWithArgreturnerror = async (url, data) => {
  try {
    const response = await tairraAxiosInstance.put(url, data);
    return response.data;
  } catch (error) {
    console.error('Failed to update:', error);
    return error;
  }
};
